module.exports = "/img/6.72cda3.webp";